<template>
  <div class="mycourse">
    <Row class="top-title" type="flex" justify="space-between" align="bottom">
      <i-col span="8" class="title-left">
        <span>我的课程</span>
        <router-link to="/mymenu">我的首页</router-link>
      </i-col>
    </Row>

    <Tabs size="small" style="width: 1275px; margin: 0 auto"  v-model="activeKeyNum">
      <TabPane label="我的课程">
        <Row class="course-tip">
          <i-col span="15">
            <div v-if="'courseName' in newCourse">
              您好，{{ newCourse.realname }}，您有一门《{{
                newCourse.courseName
              }}》课程即将在
              <span>{{ newCourse.openTime }}</span>
              进行开课
            </div>
            <div v-else>暂没有即将开课的课程</div>
          </i-col>
          <i-col span="9">
            <Poptip
              title="课程表"
              placement="bottom"
              width="320"
              style="color: black"
            >
              <div style="color: white">
                <img
                  style="display: inline-block; height: 30px"
                  src="@/assets/mycourse/calendar.png"
                  alt
                />
                <h3 style="display: inline">我的课程表</h3>
              </div>
              <Row class="course-schedule" slot="content">
                <i-col
                  v-for="(item, index) in courseSchedule"
                  :key="index"
                  style="
                    border-radius: 10px;
                    margin-top: 10px;
                    background: rgba(0, 0, 0, 0.2);
                    text-indent: 10px;
                  "
                >
                  <p>{{ item.openTime }} {{ item.unitName }}</p>
                </i-col>
              </Row>
            </Poptip>
          </i-col>
        </Row>

        <Carousel v-if="courseResult.records" arrow="always" dots="none">
          <CarouselItem v-for="i in caroulLength" :key="i.id">
            <Row type="flex" justify="space-around" class="my-carousel">
              <i-col
                span="7"
                class="card-item"
                v-for="(item, index) in courseResult.records.slice(
                  (i - 1) * 3,
                  i * 3
                )"
                :key="index"
              >
                <Card
                  :bordered="false"
                  :class="[item.isCourseStart ? '' : 'gray']"
                >
                  <div class="course-cover" @click="toUnitMap(item)">
                    <div class="next-unit" v-if="item.id in nextUnits">
                      <p>{{ nextUnits[item.id].unitName }}</p>
                      <p>{{ nextUnits[item.id].openTime }}</p>
                    </div>
                    <img :src="item.courseCoverFileUrl" alt />
                  </div>
                  <p>
                    <Button
                      @click="toUnitMap(item)"
                      type="primary"
                      shape="circle"
                      >{{ item.courseType_dictText }}</Button
                    >
                  </p>
                  <p>{{ item.courseName }}</p>
                  <p>
                    {{
                      item.isCourseStart
                        ? item.courseDesc
                        : item.openTime
                        ? item.openTime + "开课"
                        : "未开课"
                    }}
                  </p>

                  <Progress :percent="item.finishedWork/item.totalWork*100">
                    <span>{{ item.finishedWork }} / {{ item.totalWork }}</span>
                  </Progress>
                </Card>
              </i-col>
            </Row>
          </CarouselItem>
        </Carousel>
      </TabPane>
      <TabPane v-if="false" label="游戏课程"></TabPane>
      <TabPane label="收藏课程">
        <Row type="flex" justify="space-between">
          <i-col>
            <Select
              class="select"
              v-model="type"
              size="small"
              style="width: 150px"
            >
              <Option value="0">全部分类</Option>
              <Option value="1">scratch</Option>
              <Option value="2">python</Option>
              <Option value="3">c++</Option>
            </Select>
          </i-col>
          <i-col>
            <Input search class="search" placeholder="请输入搜索内容" />
          </i-col>
        </Row>
        <Row class="course-list">
          <i-col span="5" v-if="false" class="course-item">
            <card :bordered="false">
              <img src="@/assets/mycourse/p1.png" alt />
              <p class="title">scratch1级</p>
              <p>scratch</p>
              <span>初学者</span>
            </card>
          </i-col>
        </Row>
      </TabPane>
      <TabPane label="今日任务">
        <Row type="flex" justify="space-between">
          <i-col>
            <Select
              class="select"
              v-model="type"
              size="small"
              style="width: 150px"
            >
              <Option value="0">全部分类</Option>
              <Option value="1">scratch</Option>
              <Option value="2">python</Option>
              <Option value="3">c++</Option>
            </Select>
          </i-col>
        </Row>
        <Row
          class="course-list"
          style="
            border-radius: 20px;
            background: rgba(255, 255, 255, 0.18);
            margin-top: 20px;
            padding: 20px;
          "
        >
        <i-col
            span="5"
            class="course-item"
            v-for="(item, index) in additionalWork"
          :key="index"
          >
            <card :bordered="false">
              <img :src="item.workCoverUrl" @click="toAdditionalWork(item)" alt />
              <p class="title" @click="toAdditionalWork(item)">
                {{ (item.workName?item.workName:'无标题') }}
              </p>
              <p>
                {{item.workDesc}}
              </p>
              <div class="footer-content">
                <!-- <span>{{item.createTime}}</span> -->
                <span>{{ (item.workIntegral?item.workIntegral:0)}} 积fun</span>
              </div>
            </card>
        </i-col>
          <!-- <div @click="toAdditionalWork(item)">
            <i-col span="7" class="course-item">
              <img
                style="width: 296px; height: 179px; border-radius: 20px"
                :src="item.workCoverUrl"
                alt
              />
            </i-col>
            <i-col span="12" style="text-align: left">
              <h1>{{ item.workName }}</h1>
              <h3>{{ item.workDesc }}</h3>
            </i-col>
            <i-col span="5">
              <div
                style="
                  background-color: rgba(142, 116, 231, 1);
                  border-radius: 15px;
                  width: 113px;
                  height: 110px;
                  margin-top: 40px;
                "
              >
                <h3 style="line-height: 110px">{{ item.workIntegral }}积fun</h3>
              </div>
            </i-col>
          </div> -->
        </Row>
      </TabPane>
      <TabPane label="我的评价">
        <Table
          class="rank-table"
          :content="self"
          :columns="reviewColumns"
          :data="mineReviewResult.records"
        >
          <template slot-scope="{ row }" slot="action">
            <Button
              type="primary"
              size="small"
              style="margin-right: 5px"
              @click="toWork(row)"
              >查看作业</Button
            >
          </template>
        </Table>
      </TabPane>
      <TabPane label="排行榜">
        <Row class="rank-list" type="flex" align="middle" justify="center">
          <i-col span="4" class="rank-title">
            <a href="javascript:void(0)" @click="communityCattle('integral')">
              <svg-icon icon-class="money" style="font-size: 36px"></svg-icon>
              <span>金币排行榜</span>
            </a>
          </i-col>
          <i-col span="4" class="rank-title">
            <a href="javascript:void(0)" @click="communityCattle('integral')">
              <svg-icon icon-class="rank1" style="font-size: 36px"></svg-icon>
              <span>等级排行榜</span>
            </a>
          </i-col>
          <i-col span="4" class="rank-title">
            <a href="javascript:void(0)" @click="communityCattle('awardNum')">
              <svg-icon icon-class="xz" style="font-size: 36px"></svg-icon>
              <svg-icon icon-class="star2" class="star2"></svg-icon>
              <span>勋章排行榜</span>
            </a>
          </i-col>
          <i-col span="4" class="rank-title">
            <a href="javascript:void(0)" @click="communityCattle('idolNum')">
              <svg-icon icon-class="qw" style="font-size: 36px"></svg-icon>
              <span>人气排行榜</span>
            </a>
          </i-col>
        </Row>
        <Table class="rank-table" :columns="columns1" :data="data1"></Table>
      </TabPane>
    </Tabs>

    <Modal
      v-model="isShowUploadWork"
      class-name="vertical-center-modal"
      okText="开始上传"
      @on-ok="upload"
      class="work-modal"
      width="800"
    >
      <div class="work-content">
        <Row>
          <i-col span="3">
            <span class="status-title">手动上传：</span>
          </i-col>
          <i-col span="20">
            <Upload
              ref="upload"
              :accept="Accept"
              :before-upload="handleUpload"
              :action="uploadAction"
              :data="getUploadData()"
              :on-success="onUploadSuccess"
            >
              <Button icon="ios-cloud-upload-outline" :disabled="uploadSuccess"
                >选择文件</Button
              >
            </Upload>
            <p>支持文件格式：图片、文档、压缩包，单个文件不能超过10M</p>
          </i-col>
        </Row>
      </div>
      <div class="work-status">
        <Row v-show="fileList.length > 0">
          <i-col span="3">
            <span class="status-title">上传状态：</span>
          </i-col>
          <i-col span="20">
            <div
              class="file-item"
              v-for="(item, index) in fileList"
              :key="index"
            >
              <span>{{ item.name }} </span>
              <span
                class="text"
                @click="cancleFile(index)"
                v-show="!uploadSuccess"
              ></span>
              <span class="success" v-show="uploadSuccess">上传成功</span>
            </div>
          </i-col>
        </Row>
      </div>
      <div slot="footer" class="work-footer">
        <Button
          v-show="fileList.length > 0 && !uploadSuccess"
          @click="upload"
          :loading="loadingStatus"
          >{{ loadingStatus ? "上传中" : "开始上传" }}</Button
        >
      </div>
    </Modal>
  </div>
</template>
<script>
import { getAction, postAction } from "@/api";
import {
  getMineCourse,
  getMineReview,
  getNewCourse,
  mineAdditionalWork,
  getCourseUnit,
} from "@/api/course";
import { removeToken, removeUserInfo } from "@/utils/auth";
import { communityCattle } from "@/api/community";
export default {
  components: {},
  data() {
    return {
      type: "0",
      self: this,
      reviewColumns: [
        {
          title: "作业",
          key: "workName",
        },
        { title: "评语", key: "review" },
        { title: "时间", key: "createTime" },
        {
          title: "操作",
          key: "action",
          slot: "action",
        },
      ],
      columns1: [
        {
          title: "排名",
          type: "index",
          align: "center",
        },
        {
          title: "用户",
          key: "realname",
        },
        {
          title: "等级",
          key: "level",
        },
        {
          title: "人气",
          key: "idol",
        },
        {
          title: "金币数量",
          key: "integral",
        },
        {
          title: "勋章数量",
          key: "awardNum",
        },
        {
          title: "发布作品数量",
          key: "workNum",
        },
      ],
      data1: [],
      courseResult: [],
      mineReviewResult: {},
      newCourse: {},
      courseSchedule: [],
      userIntegralRankList: [],
      caroulLength: "1",
      additionalWork: [],
      nextUnits: {},
      activeKeyNum: 0,

      fileList: [],
      uploadToken: "",
      isShowUploadWork: false,
      uploadSuccess: false,
      loadingStatus: false,
      uploadAction: "//upload-" + window._CONFIG["qn_area"] + ".qiniup.com",
      Accept: ".pdf,.doc,.docx,.zip,.rar,.png,.jpg,.bmp,.jpeg,.gif", //上传文件格式限制
    };
  },
  created() {
    this.getMineCourse(1, 99);
    this.getMineReview();
    this.getNewCourse();
    // this.communityCattle("integral");
    // this.getAdditionalWork();
  },
  watch: {
    activeKeyNum(val, old) {
      this.additionalWork = {};
      this.userIntegralRankList = {};
      this.data1 = []
      if (val == 2) {
        this.getAdditionalWork();
      }else if(val == 4){
        this.communityCattle("integral");
      }

    },
  },
  methods: {
    handleUpload(file) {
      if (this.uploadSuccess) {
        this.$Message.warning("已上传成功");
        return false;
      }
      let l10M = 10 * 1024 * 1024;
      if (file.size > l10M) {
        this.$Message.warning("单个文件不能超过10M");
        return false;
      }
      // this.getQiniuToken();
      this.fileList.push(file);
      this.fileList = this.fileList.slice(-1);
      return false;
    },
    upload() {
      if (this.fileList.length == 0) {
        return;
      }
      if (this.loadingStatus) return;
      this.loadingStatus = true;
      console.log(this.fileList);
      let file = this.fileList[0];
      this.$refs.upload.post(file);
    },
    onUploadSuccess(res, file) {
      console.log(res);
      console.log(file);
      this.saveToDB(file.name, file.response.key, 1, "学生附加作业上传").then(
        (r) => {
          if (r.success) {
            let fileId = r.result.id;
            this.submitWork(this.additionalId, fileId, file.name).then((res) => {
              this.fileList = [];
              this.loadingStatus = false;
              this.$Message.success("上传成功");
              this.uploadSuccess = true;
            });
          }
        }
      );
    },
    getUploadData() {
      if (this.fileList.length == 0) {
        return;
      }
      console.log(this.fileList);
      let file = this.fileList[0];
      var suffix = file.name.split(".").pop();
      return {
        token: this.uploadToken,
        key: this.uuidGenerator() + "." + suffix,
      };
    },
    //获取七牛TOKEN
    getQiniuToken() {
      getAction("/api/common/qiniu/getToken", {}).then((res) => {
        if (res.success) {
          this.uploadToken = res.result;
        } else {
          this.$Message.error(res.message);
        }
      });
    },
    submitWork(additionalId, fileId, workName) {
      return postAction("/api/teaching/teachingWork/submit", {
        additionalId: additionalId,
        workFile: fileId,
        workType: 0,
        workScene: 'additional',
        workName: workName
      });
    },
    saveToDB: function (fileName, filePath, fileLocation, fileTag) {
      return postAction("/api/system/sysFile/add", {
        fileName: fileName,
        filePath: filePath,
        fileLocation: fileLocation,
        fileTag: fileTag,
      });
    },
    delFromBD(filePath) {
      return getAction("/api/system/sysFile/deleteByPath", {
        filePath: filePath,
      });
    },
    uuidGenerator() {
      var s = [];
      var hexDigits = "0123456789abcdef";
      for (var i = 0; i < 36; i++) {
        s[i] = hexDigits.substr(Math.floor(Math.random() * 0x10), 1);
      }
      s[14] = "4"; // bits 12-15 of the time_hi_and_version field to 0010
      s[19] = hexDigits.substr((s[19] & 0x3) | 0x8, 1); // bits 6-7 of the clock_seq_hi_and_reserved to 01
      s[8] = s[13] = s[18] = s[23] = "-";
      var uuid = s.join("");
      return uuid;
    },
    communityCattle(orderBy) {
      communityCattle(orderBy, 1, 20).then((res) => {
        if (res.success) {
          this.userIntegralRankList = res.result.records;
          this.data1 = this.userIntegralRankList;
        }
      });
    },
    rankData(key) {
      this.data1.sort(this.compare(key));
    },
    // 根据元素排序
    compare(property) {
      return (a, b) => {
        var value1 = a[property];
        var value2 = b[property];
        return value1 - value2;
      };
    },
    getMineCourse() {
      let that = this;
      getMineCourse(1, 99).then((res) => {
        if (res.success) {
          //查询每节课的单元信息
          for (var i = 0; i < res.result.records.length; i++) {
            var course = res.result.records[i];
            getCourseUnit(course.departId, course.id, 1, 99).then((r) => {
              if (r.result == null) {
                return;
              }
              var units = r.result.records;
              //计算下一次开课的一个单元
              for (var j = 0; j < units.length; j++) {
                if (!units[j].isOpen) {
                  that.$set(this.nextUnits, units[j].courseId, units[j]);
                  // that.nextUnits[units[j].courseId] = units[j];
                  break;
                }
              }
            });
          }
          this.courseResult = res.result;
          this.caroulLength = Math.ceil(res.result.records.length / 3);
        }
      });
    },
    getMineReview() {
      getMineReview().then((res) => {
        if (res.success) {
          this.mineReviewResult = res.result;
        }
      });
    },
    getNewCourse() {
      getNewCourse().then((res) => {
        if (res.success) {
          this.courseSchedule = res.result;
          if (res.result.length > 0) {
            this.newCourse = res.result[0];
          }
        }
      });
    },
    getAdditionalWork() {
      mineAdditionalWork().then((res) => {
        if (res.success) {
          this.additionalWork = res.result.filter(item=>{
            return item.mineWorkId == null || item.mineWorkStatus == 0;
          });
        }
      });
    },
    toUnitMap(course) {
      if (course.isCourseStart) {
        this.$router.push({
          path: `/myunit?courseId=${course.id}&departId=${course.departId}`,
        });
      } else {
        this.$Message.info("未开课");
      }
    },
    toAdditionalWork(item) {
      if (item.workType == 2) {
        window.open(
          "/static/scratch3/index.html?scene=additional&additionalId=" +
            item.id +
            "&workFile=" +
            item.workFileUrl +
            "&workName=" +
            item.workName 
            // item.mineWorkId?("&workId=" + item.mineWorkId):""
        );
      } else {
        this.additionalId = item.id;
        this.isShowUploadWork = true;
        this.getQiniuToken();
      }
    },
    toWork(work) {
      if(work.workType==1||work.workType==2){
        window.open("/static/scratch3/index.html?scene=create&workId=" + work.workId);
      }else{
        window.open(work.workFileUrl);
      }
    },
  },
};
</script>
<style lang="scss">
.gray {
  -webkit-filter: grayscale(100%);
  -moz-filter: grayscale(100%);
  -ms-filter: grayscale(100%);
  -o-filter: grayscale(100%);
  filter: grayscale(100%);
  filter: gray;
}
.mycourse {
  .ivu-tabs-bar {
    border: none;
  }
  .ivu-tabs-ink-bar {
    display: none;
  }
  .ivu-tabs {
    .ivu-tabs-tab {
      width: 200px;
      height: 80px;
      color: #fff;
      font-weight: 700;
      font-size: 20px;
      line-height: 50px;
      &:hover {
        color: unset;
      }
    }
    .ivu-tabs-nav .ivu-tabs-tab-active {
      background-image: url("../../assets/mycourse/u1807.png"),
        url("../../assets/mycourse/u1806.png");
      background-size: 67px 61px, 200px 45px;
      background-repeat: no-repeat, no-repeat;
      background-position: 0 0, 15px 10px;
      color: #333;
      font-size: 16px !important;
    }
  }

  .ivu-progress-outer {
    margin-top: 15px;
  }
  .ivu-progress-bg {
    background-color: rgba(48, 168, 206, 1);
  }

  .card-item:nth-child(2n) .ivu-progress-bg {
    background-color: rgba(109, 202, 157, 1);
  }
  .card-item .ivu-card-body {
    padding: 30px 0;
    img {
      width: 100%;
      height: 100%;
    }
  }
  .course-list .course-item .ivu-card-body {
    padding: 0;
  }
  .rank-table {
    border: 1px solid #4d4475;
    border-radius: 15px;
    line-height: 50px;
    margin: 50px 0;
    opacity: 0.7;
    .ivu-table-body {
      overflow: hidden;
    }
    .ivu-table {
      background-color: rgba(32, 48, 108, 0.4);
      color: #fff;
      .ivu-table-header thead tr th {
        background-color: rgba(32, 48, 108, 0.4);
        border-color: #4d4475;
      }
      td {
        background-color: rgba(32, 48, 108, 0.4);
        border-color: #4d4475;
      }
      &::before {
        background-color: #4d4475;
      }
    }
    .ivu-table-border::after {
      background-color: #4d4475;
    }
  }
}
</style>
<style lang="scss" scoped>
.mycourse {
  width: 1280px;
  margin: 0 auto;
  .top-title {
    width: 1360px;
    margin: 40px auto;
    .title-left {
      color: #fff;
      span {
        font-weight: 700;
        margin-right: 50px;
        font-size: 30px;
      }
      a {
        font-weight: 700;
        font-size: 20px;
        background: rgb(57, 165, 239);
        display: inline-block;
        border-radius: 30px;
        line-height: 30px;
        padding: 5px 36px;
      }
    }
    .title-right {
      font-size: 20px;
      color: #192648;
      border-radius: 30px;
      background: #fff;
      line-height: 40px;
      padding: 0px 36px;
      height: 40px;
      cursor: pointer;
      &:hover {
        background: #f5c54a;
        color: #fff;
      }
    }
  }
  .course-tip {
    color: #fff;
    font-size: 20px;
    text-align: left;
    margin-top: 50px;
    margin-bottom: 80px;
    text-indent: 30px;
    span {
      color: #f0f288;
      font-weight: 700;
    }
  }
  .my-carousel {
    .card-item {
      width: 295px;
      opacity: 0.7;
      .course-cover {
        height: 160px;
        .next-unit {
          opacity: 0;
          position: absolute;
          font-size: 20px;
          color: white;
          width: 100%;
          text-align: center;
          text-shadow: 0px 0px 10px black;
          background: #0000009c;
          height: 160px;
        }
      }
      &:hover {
        opacity: 1;
        .next-unit {
          opacity: 1;
        }
      }
      p {
        margin-top: 20px;
      }
      button {
        font-size: 17px;
        font-weight: 700;
        width: 135px;
        height: 46px;
        background: rgba(48, 168, 206, 1);
        border-color: rgba(48, 168, 206, 1);
      }
      &:nth-child(2n) {
        button {
          background: rgba(109, 202, 157, 1);
          border-color: rgba(109, 202, 157, 1);
        }
      }
    }
  }
  .course-list {
    margin-top: 30px;
    font-size: 0;
    .course-item {
      width: 227px;
      margin-right: 20px;
      position: relative;
      img {
        width: 227px;
        height: 134px;
        border-radius: 4px;
      }
      p {
        text-align: left;
        padding: 5px 20px 10px;
        &.title {
          font-size: 18px;
          font-weight: 700;
        }
        font-size: 14px;
      }
      span {
        position: absolute;
        top: 121px;
        right: 20px;
        color: #fff;
        background: rgba(109, 202, 157, 1);
        font-size: 12px;
        padding: 2px 20px;
        border-radius: 3px;
      }
    }
  }
  .rank-list {
    margin-top: 40px;
    .rank-title {
      font-size: 20px;
      color: #fff;
      position: relative;
      .star2 {
        font-size: 16px;
        position: absolute;
        left: 45px;
        top: 6px;
      }
    }
    span {
      margin-left: 5px;
      vertical-align: text-bottom;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/my/mycourse.vue